import React, { useEffect, useState } from 'react';
import api from '../api';
import BackButton from '../components/BackButton';

export default function CashBankAccountsPage() {
  const [accounts, setAccounts] = useState([]);
  const [form, setForm] = useState({ AccountName: '', OpeningBalance: 0 });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchAccounts();
  }, []);

  function fetchAccounts() {
    api.get('/cashbank-accounts').then(res => setAccounts(res.data));
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (editingId) {
      api.put(`/cashbank-accounts/${editingId}`, { OpeningBalance: form.OpeningBalance })
        .then(() => {
          setEditingId(null);
          setForm({ AccountName: '', OpeningBalance: 0 });
          fetchAccounts();
        });
    } else {
      api.post('/cashbank-accounts', form).then(() => {
        setForm({ AccountName: '', OpeningBalance: 0 });
        fetchAccounts();
      });
    }
  }

  function handleEdit(account) {
    setEditingId(account.AccountID);
    setForm({ AccountName: account.AccountName, OpeningBalance: account.OpeningBalance });
  }

  return (
    <div className="container mt-4">
        <BackButton></BackButton>
      <h2>Manage Cash/Bank Accounts</h2>
      
      <form onSubmit={handleSubmit} className="mb-4 row g-2 align-items-end">
        <div className="col-md-4">
          <input
            type="text"
            name="AccountName"
            placeholder="Account Name (e.g. Cash, SBI Bank)"
            value={form.AccountName}
            className="form-control"
            onChange={handleChange}
            disabled={!!editingId}
            required
          />
        </div>
        <div className="col-md-3">
          <input
            type="number"
            name="OpeningBalance"
            placeholder="Opening Balance"
            value={form.OpeningBalance}
            className="form-control"
            onChange={handleChange}
            required
            min="0"
            step="0.01"
          />
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary w-100" type="submit">
            {editingId ? 'Update Balance' : 'Add Account'}
          </button>
        </div>
        {editingId && (
          <div className="col-md-2">
            <button className="btn btn-secondary w-100" type="button" onClick={() => {
              setEditingId(null);
              setForm({ AccountName: '', OpeningBalance: 0 });
            }}>
              Cancel
            </button>
          </div>
        )}
      </form>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Account Name</th>
            <th>Opening Balance</th>
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map(ac => (
            <tr key={ac.AccountID}>
              <td>{ac.AccountName}</td>
              <td>{Number(ac.OpeningBalance).toFixed(2)}</td>
              <td>{ac.CreatedAt ? new Date(ac.CreatedAt).toLocaleString() : ''}</td>
              <td>
                <button className="btn btn-sm btn-info" onClick={() => handleEdit(ac)}>
                  Edit Balance
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
